import Vue from 'vue'
import Router from 'vue-router'
import index from '../app/index'
import index2 from '../app/index2'
import myReports from '../app/myReports'
import admin from '../app/admin'
import biz from '../app/biz'
import orders from '../app/orders'
import help from '../app/help'
import service from '../app/service'
import developer from '../app/developer.vue'
import wechat from '../app/wechat.vue'
import hk from '../app/hk.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    { path: '/help', name: 'home', component: help },
    { path: '/developer', name: 'developer', component: developer },
    { path: '/orders', name: 'orders', component: orders },
    { path: '/', name: 'index', component: index },
    { path: '/index', name: 'index', component: index },
    { path: '/hk', name: 'hk', component: hk },
    { path: '/index2', name: 'index2', component: index2 },
    { path: '/admin', name: 'admin', component: admin },
    { path: '/biz', name: 'admin', component: biz },
    { path: '/service', name: 'service', component: service },
    { path: '/wechat', name: 'wechat', component: wechat },
    { path: '/myReports', name: 'myReports', component: myReports }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js